import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import AnswerItem from '@widgets/SteppedQuiz/components/AnswerItem';
import { Tooltip } from 'react-tooltip';
import { Wrapper, List, TooltipButton, Icon, ExtrasWrapper, } from './styles';
function QuestionItem(props) {
    const { heading, answers, tooltip, icon, tag, id, } = props;
    const { size, title } = heading;
    return (_jsxs(Wrapper, { children: [(icon || tag)
                && (_jsxs(ExtrasWrapper, { children: [icon
                            && (_jsx(Icon, { children: _jsx("use", { xlinkHref: icon }) })), tag
                            && (_jsx("span", { className: "tag tag--category", children: tag }))] })), tooltip
                && (_jsxs("div", { children: [_jsx(TooltipButton, { className: "tooltip", children: "?" }), _jsx(Tooltip, { anchorSelect: ".tooltip", place: "top", children: tooltip })] })), _jsx("span", { className: size ?? 'h6', children: title }), answers && (_jsx(List, { children: answers.map((answer) => (_jsx(AnswerItem, { ...answer, questionId: id }))) }))] }));
}
export default QuestionItem;
